export default Object.freeze({

    //Entity names used to access correct data in the entity container store.
    Article: 'Article',
    Contract: 'Contract',
    Counter: 'Counter',
    Customer: 'Customer',
    CustomerGroup: 'CustomerGroup',
    Department: 'Department',
    JobCategory: 'JobCategory',
    Machine: 'Machine',
    MachineModel: 'MachineModel',
    MachineType: 'MachineType',
    PartnerCompany: 'PartnerCompany',
    Project: 'Project',
    Supplier: 'Supplier',
    Unit: 'Unit',
    CheckList: 'CheckList'
});